import React from 'react';
import { useNavigate } from 'react-router-dom';

function PageNotFound() {
  const navigate = useNavigate();

  return (
    <form className="form">
      <div className="form__control">
        <h4 className="heading-4 u-margin-bottom-xxl">Page Not Found!</h4>

        <button
          className="btn btn__form u-margin-bottom-m"
          onClick={() => {
            navigate('/');
          }}
        >
          Return
        </button>
      </div>
    </form>
  );
}

export default PageNotFound;
